import React, { useState } from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useAuthUser } from 'react-auth-kit';

// GRAPHQL QUERY
import { 
    SaveUser
} from './users_graphql.js';

// DOCS: https://www.apollographql.com/docs/react/get-started/
// Import everything needed to use the `useQuery` hook
import { useMutation } from '@apollo/client';



export function PlayerCardComponent(props) {

    const [BaseState, setBaseState] = useState({ editing: props.editing});

    return (
        <div className="card h-100">
            <div className="card-header h4 border border-secondary">
                <span className={`float-start mt-1 ${!props.card_open && 'text-muted'}`} onClick={() => props.setCardOpenPlayerDetails(!props.card_open)}>
                    {(props.card_open && <FontAwesomeIcon icon="fa-chevron-down" className="me-2" />) || <FontAwesomeIcon icon="fa-chevron-right" className="me-2" />}
                    Player Details
                </span>
                <span className="float-end">
                    <button className="btn btn-sm fw-bold col-auto border-primary border-3 text-primary float-end" onClick={() => setBaseState({ ...BaseState, editing: true})} disabled={BaseState.editing}>
                        <FontAwesomeIcon icon="fa-pencil" className="me-2" />Edit
                    </button>
                </span>
            </div>

            {/* Conditional show the body content based on the chevron for props.card_open */}
            {
                props.card_open &&
                <div className="card-body border border-secondary border-top-0">
                    <PlayerDetailsComponent 
                        Player={{...props.Player}} 
                        editing={BaseState.editing} 
                        handleCancelEdit={() => setBaseState({...BaseState, editing: false})} 
                        refreshPlayerListAfterAdd={(user) => props.refreshPlayerListAfterAdd(user)}     
                    />
                </div>
            }

            {
                parseInt(props.Player.user_ID) > 0 &&
                <div className="card-footer text-center border border-secondary border-top-0">
                    {
                        props.Player.date_updated !== null &&
                        <span className="float-end"><span className="text-muted">Last Updated:</span> {dayjs(props.Player.date_updated).format('M-D-YY h:mm a')}</span>
                    }
                    {
                        props.Player.date_created !== null &&
                        <span className="float-start"><span className="text-muted">Created:</span> {dayjs(props.Player.date_created).format('M-D-YY h:mm a')}</span>
                    }
                </div>
            }
        </div>

    )
}

export function PlayerDetailsComponent(props) {
    const auth = useAuthUser();
    const athletic = auth().User.athletic;
    const medical = auth().User.medical;

    const [MasterPlayer, setMasterPlayer] = useState({ ...props.Player });
    const [SelectedUser, setSelectedUser] = useState({ ...props.Player, save_button_text: 'Save', save_message: '' });

    const [save_user] = useMutation(SaveUser);

    // Update the state for any changing input
    function changeInputValue(name, value) {
        // For inputs that must be integers, do not allow non numeric characters, and parseInt on the value
        if ( name === 'corresponding_hole_house' || name === 'corresponding_hole_infra' || name === 'corresponding_hole_subscap' || name === 'corresponding_hole_supra' || name === 'corresponding_hole_teres' ) {
            if(value !== '') {
                value = parseInt(value)
                // Prevent 'NaN' 
                if( isNaN(value) ) {
                    value = null;
                }
            } else {
                // This is to avoid attempting to save "" as an INT
                value = null;
            }
        } 
        // else if ( name === 'sale_price' || name === 'scrap_percentage_cost_sheet' || name === 'standard_tool_cost' ) {
        //     if(value !== '') {
        //         // Strips non-numeric characters, leaves decimal
        //         value = value.replace(/[^\d.-]/g, '');
        //         // Handle decimal length restrictions
        //         if (value.includes('.')) {
        //             let decimal_length = value.split('.')[1].length;
        //             if( (name === 'sale_price' || name === 'standard_tool_cost' ) && decimal_length > 4 ) {
        //                 value = parseFloat(value).toFixed(4)
        //             } else if ( name === 'scrap_percentage_cost_sheet' && decimal_length > 2 ) {
        //                 value = parseFloat(value).toFixed(2)
        //             }
        //         };
        //     }
        // } 
        console.log("Name: ", name, " | Value: ", value)
        setSelectedUser({
            ...SelectedUser, 
            [name]: value 
        });
    }

    // Cancel Editing and revert back any unsaved changes
    function handleCancel() {
    
        // Reset this form to unsaved values
        setSelectedUser({
            ...SelectedUser,
            ...MasterPlayer
        });

        // Tell parent function that this is canceled, which disables the form
        props.handleCancelEdit()
    }
    // Save Player Details
    async function handleSave() {
        let SaveData = {...SelectedUser};

        // Parse string values that are IDs to be integers, saving stringified numbers to the database throws an error.
        let MakeIntegers = [ 'user_ID', 'archiver_ID', 'corresponding_hole_house', 'corresponding_hole_infra', 'corresponding_hole_subscap', 'corresponding_hole_supra', 'corresponding_hole_house', 'creator_ID', 'customer_ID', 'height_feet', 'player_number', 'user_type_ID', 'updater_ID'];
        

        MakeIntegers.forEach((mi) => SaveData[mi] = parseInt(SaveData[mi]));

        // Remove save mesasge and button text from User object for saving
        SaveData = _.omit(SaveData, ['date_last_benchmark','date_last_workout','save_button_text','save_message']);

        // Add creator_ID and customer_ID, or updater_ID depending on if there is a user_ID for the player being saved
        SaveData = parseInt(SaveData.user_ID) > 0 ? {...SaveData, updater_ID: parseInt(auth().User.user_ID)} : {...SaveData, creator_ID: parseInt(auth().User.user_ID), customer_ID: parseInt(auth().User.customer_ID)};

        const result = await save_user({ variables: { input: { ...SaveData } }});
        console.log({result})
        // Update the Users - save returns an array of all User objects
        if(result.data && result.data.userSave.User) {

            // If this was a create, update the User object with the new user_ID
            if(parseInt(SaveData.user_ID) === 0) {

                // Update the button and save message to show for created success
                setSelectedUser({
                    ...SelectedUser,
                    user_ID: parseInt(result.data.userSave.User.user_ID),
                    save_button_text: 'Saved',
                    save_message: 'Successfully Created'
                });

                // Tell Player List to refetch the Player list, but still leave this profile open
                props.refreshPlayerListAfterAdd({...result.data.userSave.User});
            } else {
            

                // Update the User with the new user_ID that was created
                setSelectedUser({
                    ...SelectedUser,
                    save_button_text: 'Saved',
                    save_message: 'Successfully Updated'
                });

            }

            setMasterPlayer({
                ...result.data.userSave.User
            })
            
            // // For insert and update, set the action and new Users
            // setBaseState({
            //     ...BaseState,
            //     action: temp_action,
            //     Users: TempUsers
            // });

            // // Update the User in the parent component's list of Users
            // props.handleChangeParentBaseState(props.action, TempUsers)
        }
    }

    console.log({SelectedUser})
    return (
        <div className="clearfix">
            {   
                parseInt(SelectedUser.user_ID) === 0 && 
                <div className="alert alert-sm alert-danger">
                    <ul className="mb-0 ps-3">
                        <li>Complete and save this form before add workout or benchmark entries.</li>
                        <li>Arm and Forearm lengths must be added to calculate workout torque.</li>
                        <li>Phone number must be added for advanced login to NuShoulder machine.</li>
                    </ul>
                </div>
            }
            <div className="row mx-0">
                <div className="form-floating mb-2 col-6 p-0 pe-1">
                    <input className="form-control float" disabled={!props.editing} id="first_name" value={SelectedUser.first_name} onChange={(event) => changeInputValue('first_name', event.target.value)} /> 
                    <label className="text-muted" htmlFor="first_name">First Name *</label>
                </div>
                <div className="form-floating mb-2 col-6 p-0 ps-1">
                    <input className="form-control float" disabled={!props.editing} id="last_name" value={SelectedUser.last_name} onChange={(event) => changeInputValue('last_name', event.target.value)} /> 
                    <label className="text-muted" htmlFor="last_name">Last Name *</label>
                </div>
            </div>
            <div className="row mx-0">
                <div className="form-floating mb-2 col-6 p-0 pe-1">
                    <input className="form-control float" disabled={!props.editing} id="phone_number" value={SelectedUser.phone_number} onChange={(event) => changeInputValue('phone_number', event.target.value)} /> 
                    <label className="text-muted" htmlFor="phone_number">Phone Number *</label>
                </div>
                {
                    athletic === 1 &&
                    <div className="form-floating mb-2 col-6 p-0 ps-1">
                        <input className="form-control float" disabled={!props.editing} id="sport" value={SelectedUser.sport} onChange={(event) => changeInputValue('sport', event.target.value)} /> 
                        <label className="text-muted" htmlFor="sport">Sport</label>
                    </div>
                }
                {
                    medical === 1 &&
                    <div className="form-floating col-6 p-0 ps-1">
                        <input type="date" className="form-control" disabled={!props.editing} id="date_birth" value={SelectedUser.date_birth || ""} onChange={(event) => changeInputValue('date_birth', event.target.value)} />
                        <label className="text-muted" htmlFor="date_birth">Date of Birth</label>
                    </div>
                }
            </div>
            {
                athletic === 1 &&
                <div className="row mx-0">
                    <div className="form-floating mb-2 col-6 p-0 pe-1">
                        <input className="form-control float" disabled={!props.editing} id="player_position" value={SelectedUser.player_position} onChange={(event) => changeInputValue('player_position', event.target.value)} /> 
                        <label className="text-muted" htmlFor="player_position">Postion</label>
                    </div>
                    <div className="form-floating mb-2 col-6 p-0 ps-1">
                        <input className="form-control float" disabled={!props.editing} id="player_number" value={SelectedUser.player_number} onChange={(event) => changeInputValue('player_number', event.target.value)} /> 
                        <label className="text-muted" htmlFor="player_number">Jersey Number</label>
                    </div>
                </div>
            }
            <div className="row mx-0">
                <div className="form-floating mb-2 col-6 p-0 pe-1">
                    <input className="form-control float" disabled={!props.editing} id="arm_length_left" value={SelectedUser.arm_length_left} onChange={(event) => changeInputValue('arm_length_left', event.target.value)} /> 
                    <label className="text-muted" htmlFor="arm_length_left">Left Total Arm Length</label>
                </div>
                <div className="form-floating mb-2 col-6 p-0 ps-1">
                    <input className="form-control float" disabled={!props.editing} id="arm_length_right" value={SelectedUser.arm_length_right} onChange={(event) => changeInputValue('arm_length_right', event.target.value)} /> 
                    <label className="text-muted" htmlFor="arm_length_right">Right Total Arm Length</label>
                </div>
            </div>
            <div className="row mx-0">
                <div className="form-floating mb-2 col-6 p-0 pe-1">
                    <input className="form-control float" disabled={!props.editing} id="forearm_length_left" value={SelectedUser.forearm_length_left} onChange={(event) => changeInputValue('forearm_length_left', event.target.value)} /> 
                    <label className="text-muted" htmlFor="forearm_length_left">Left Forearm Length</label>
                </div>
                <div className="form-floating mb-2 col-6 p-0 ps-1">
                    <input className="form-control float" disabled={!props.editing} id="forearm_length_right" value={SelectedUser.forearm_length_right} onChange={(event) => changeInputValue('forearm_length_right', event.target.value)} /> 
                    <label className="text-muted" htmlFor="forearm_length_right">Right Forearm Length</label>
                </div>
            </div>
            <div className="row mx-0">
                <div className="form-floating mb-2 col-6 p-0 pe-1">
                    <input className="form-control float" disabled={!props.editing} id="height_feet" value={SelectedUser.height_feet} onChange={(event) => changeInputValue('height_feet', event.target.value)} /> 
                    <label className="text-muted" htmlFor="height_feet">Height (feet)</label>
                </div>
                <div className="form-floating mb-2 col-6 p-0 ps-1">
                    <input className="form-control float" disabled={!props.editing} id="height_inches" value={SelectedUser.height_inches} onChange={(event) => changeInputValue('height_inches', event.target.value)} /> 
                    <label className="text-muted" htmlFor="height_inches">Height (inches)</label>
                </div>
            </div>
            <div className="row mx-0">
                <div className="form-floating col-6 p-0 pe-1">
                    <input className="form-control float" disabled={!props.editing} id="weight" value={SelectedUser.weight} onChange={(event) => changeInputValue('weight', event.target.value)} /> 
                    <label className="text-muted" htmlFor="weight">Weight (lbs)</label>
                </div>
                {
                    athletic === 1 &&
                    <div className="form-floating col-6 p-0 ps-1">
                        <input type="date" className="form-control" disabled={!props.editing} id="date_birth" value={SelectedUser.date_birth || ""} onChange={(event) => changeInputValue('date_birth', event.target.value)} />
                        <label className="text-muted" htmlFor="date_birth">Date of Birth</label>
                    </div>
                }
                {
                    medical === 1 &&
                    <div className="form-floating col-6 p-0 ps-1">
                        <select 
                            className="form-select" 
                            disabled={!props.editing}
                            id="dominant_side"
                            onChange={(event) => changeInputValue('dominant_side', event.target.value)}
                            placeholder="Dominant Side"
                            value={SelectedUser.dominant_side}
                        >
                            <option key={0} value={''}>Select Side</option>
                            <option key={1} value={'left'}>Left</option>
                            <option key={2} value={'right'}>Right</option>
                        </select> 
                        <label className="text-muted" htmlFor="dominant_side">Dominant Side</label>
                    </div>
                }
            </div>
            <div className="text-center mt-2 fw-bold">NuShoulder Machine Setup Values</div>
            <div className="row mx-0">
                <div className="col-6 p-0 pe-1">
                    <div className="form-floating mb-2">
                        <input className="form-control float" disabled={!props.editing} id="corresponding_hole_supra" value={SelectedUser.corresponding_hole_supra || ""} onChange={(event) => changeInputValue('corresponding_hole_supra', event.target.value)} /> 
                        <label className="text-muted" htmlFor="corresponding_hole_supra">Supra: Dyno Hole Placement</label>
                    </div>
                    <div className="form-floating mb-2">
                        <input className="form-control float" disabled={!props.editing} id="corresponding_hole_infra" value={SelectedUser.corresponding_hole_infra || ""} onChange={(event) => changeInputValue('corresponding_hole_infra', event.target.value)} /> 
                        <label className="text-muted" htmlFor="corresponding_hole_infra">Infra: Dyno Hole Placement</label>
                    </div>
                    <div className="form-floating mb-2">
                        <input className="form-control float" disabled={!props.editing} id="corresponding_hole_teres" value={SelectedUser.corresponding_hole_teres || ""} onChange={(event) => changeInputValue('corresponding_hole_teres', event.target.value)} /> 
                        <label className="text-muted" htmlFor="corresponding_hole_teres">Teres: Dyno Hole Placement</label>
                    </div>
                    <div className="form-floating mb-2">
                        <input className="form-control float" disabled={!props.editing} id="corresponding_hole_subscap" value={SelectedUser.corresponding_hole_subscap || ""} onChange={(event) => changeInputValue('corresponding_hole_subscap', event.target.value)} /> 
                        <label className="text-muted" htmlFor="corresponding_hole_subscap">Subscap: Dyno Hole Placement</label>
                    </div>
                    <div className="form-floating">
                        <input className="form-control float" disabled={!props.editing} id="corresponding_hole_house" value={SelectedUser.corresponding_hole_house || ""} onChange={(event) => changeInputValue('corresponding_hole_house', event.target.value)} /> 
                        <label className="text-muted" htmlFor="corresponding_hole_house">House: Dyno Hole Placement</label>
                    </div>
                </div>
                <div className="col-6 p-0 ps-1">
                    <div className="form-floating mb-2">
                        <input className="form-control float" disabled={!props.editing} id="paddle_width" value={SelectedUser.paddle_width} onChange={(event) => changeInputValue('paddle_width', event.target.value)} /> 
                        <label className="text-muted" htmlFor="paddle_width">Paddle Width</label>
                    </div>
                    <div className="form-floating mb-2">
                        <input className="form-control float" disabled={!props.editing} id="seat_height" value={SelectedUser.seat_height} onChange={(event) => changeInputValue('seat_height', event.target.value)} /> 
                        <label className="text-muted" htmlFor="seat_height">Seat Height</label>
                    </div>
                    <div className="form-floating">
                        <input className="form-control float" disabled={!props.editing} id="shoulder_bolster_height" value={SelectedUser.shoulder_bolster_height} onChange={(event) => changeInputValue('shoulder_bolster_height', event.target.value)} /> 
                        <label className="text-muted" htmlFor="shoulder_bolster_height">Shoulder Bolster Height</label>
                    </div>
                    {
                        athletic === 1 &&
                        <div className="form-floating mt-2">
                            <select 
                                className="form-select" 
                                disabled={!props.editing}
                                id="dominant_side"
                                onChange={(event) => changeInputValue('dominant_side', event.target.value)}
                                placeholder="Dominant Side"
                                value={SelectedUser.dominant_side}
                            >
                                <option key={0} value={''}>Select Side</option>
                                <option key={1} value={'left'}>Left</option>
                                <option key={2} value={'right'}>Right</option>
                            </select> 
                            <label className="text-muted" htmlFor="dominant_side">Dominant Side</label>
                        </div>
                    }
                </div>
            </div>

            {/* SAVE and CANCEL buttons show when editing */}
            {
                props.editing &&
                <div className="clearfix mt-3">
                    <span className="float-start">
                        <button className="btn btn-sm fw-bold col-auto border-success border-3 text-success float-end" onClick={() => handleSave()} disabled={false}>
                            <FontAwesomeIcon icon={`${(SelectedUser.save_button_text === 'Saved' && 'fa-check') || 'fa-floppy-disk'}`} className="me-2" />{SelectedUser.save_button_text}
                        </button>
                    </span>
                    <span className="float-end">
                        <button className="btn btn-sm fw-bold col-auto border-secondary border-3 text-secondary float-end" onClick={() => handleCancel()} disabled={false}>
                            <FontAwesomeIcon icon="fa-times" className="me-2" />Cancel
                        </button>
                    </span>
                </div>
            }
        </div>
    )
}

